/* eslint-disable */
import React from 'react'
import { Link } from 'react-router-dom'
import Select, { components } from 'react-select'
import styles from '../../styles/login.css'
import CopyrightStatement from '../../components/CopyrightStatement'
import BrowserOutdatedMessage from '../../components/BrowserOutdatedMessage'
import Loading from '../../components/Loading'
import KardiaProLogo from 'static/images/kardia_pro_logo.svg'
import SignInArrow from 'static/images/icons/logout.svg'
import UsFlag from 'static/images/us-flag.svg'
import EuFlag from 'static/images/eu-flag.svg'
import ApFlag from 'static/images/ap-flag.png'
import { ROUTES, getRegion, setRegion, getAuthTimeoutError, clearAuthTimeoutError } from '../../constants'
import { VALID_AUTH_REGIONS } from 'views/pages/Auth/constants'
import { checkCNOrigin, checkAPStaging } from '../../../configs'

import classes from '../../components/CopyrightStatement/CopyrightStatement.css'

// Dropdown options
const REGION_DD = [
  { value: VALID_AUTH_REGIONS.US, label: 'US Region' },
  { value: VALID_AUTH_REGIONS.EU, label: 'EU Region' },
]

const AP_DD = { value: VALID_AUTH_REGIONS.AP, label: 'IN Region' }
const CN_DD = { value: VALID_AUTH_REGIONS.CN, label: 'CN Region' }
const CN_ICP = '美信健康科技（深圳）有限公司  粤ICP备2023066682号'

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.passwordInputRef = React.createRef()

    this.state = {
      options: REGION_DD,
      selectedOption: null,
      authTimeoutError: getAuthTimeoutError(),
      CN_Instance: false
    }
    clearAuthTimeoutError()
  }

  UNSAFE_componentWillMount() {
    const {
      options,
    } = this.state
    const region = getRegion()
    this.setState({
      selectedOption: region ? options.find(option => option.value === region) : options[0],
    })
    // check if this is not PROD env
    if (checkAPStaging()) {
      // add AP Dropdown to the DD options, only when it is ap instance
      const DD = this.state.options
      DD.push(AP_DD)
      this.setState({ options: DD })
    }

    // check if origin is China
    if (checkCNOrigin()) {
      this.setState({
        CN_Instance: true
      })
      // Default it to China Dropdown
      this.handleRegionChange(CN_DD)
      // add AP Dropdown to the DD options
      const DD = this.state.options
      DD.push(CN_DD)
      this.setState({ options: DD })
    }
  }

  componentWillUnmount() {
    const { errorMsg, clearErrorMsg } = this.props
    if (errorMsg && errorMsg.length > 0) {
      clearErrorMsg()
    }
  }

  handleRegionChange = selectedOption => {
    this.setState({ selectedOption })
    setRegion(selectedOption.value)
  }

  handleUsernameKeydown = e => {
    if (e.key === 'Enter') {
      this.passwordInputRef.focus()
    }
  }

  submitLogin = () => {
    this.setState({
      authTimeoutError: null,
    }, () => {
      this.props.handleLogin()
    })
  }

  onPasswordKeydown = evt => {
    if (evt.key === 'Enter') {
      this.setState({
        authTimeoutError: null,
      }, () => {
        this.props.handlePasswordKeyDown()
      })
    }
  }

  render() {
    const {
      errorMsg,
      isOutdatedBrowser,
      loginIsFetching,
      handlePasswordKeyDown,
      handleChange,
    } = this.props
    const {
      options,
      selectedOption,
      authTimeoutError,
      CN_Instance,
    } = this.state

    const getFlag = region => {
      let flag
      switch (region) {
        case 'us':
          flag = <UsFlag />
          break
        case 'eu':
          flag = <EuFlag />
          break
        case 'ap':
          flag = <React.Fragment><img src={ApFlag} width="20" height="14"></img> &nbsp; </React.Fragment>
          break
        default:
          break
      }
      return flag
    }

    const Option = props => {
      return (
        <div className={styles.region}>
          <components.Option {...props}>
            {getFlag(props.value)}
            {props.children}
          </components.Option>
        </div>
      )
    }

    const SingleValue = ({ children, ...props }) => {
      return (
        <div className={styles.selectedRegion}>
          <components.SingleValue {...props}>
            {getFlag(props.data.value)}
            {children}
          </components.SingleValue>
        </div>
      )
    }

    return (
      <div data-page="login" className={styles.login} >
        <div className={styles.loginOuterCont}>
          <div className={styles.loginBox}>
            <section className={styles.header}>
              <div className={styles.logo}>
                <KardiaProLogo />
              </div>
              <h1 className={styles.lr}>
                <span>S</span>
                <span>I</span>
                <span>G</span>
                <span>N</span>
                <span>I</span>
                <span>N</span>
              </h1>
            </section>

            <section className={styles.content}>
              {isOutdatedBrowser
                ? <BrowserOutdatedMessage />
                : (
                  <div className={styles.contentInner}>
                    <div className={styles.inputField}>
                      <input
                        className={styles.defaultTextInput}
                        autoComplete="new-username"
                        id="emailTextField"
                        name="username"
                        onKeyDown={this.handleUsernameKeydown}
                        onChange={handleChange}
                        type="email"
                        placeholder="Email"
                      />
                    </div>
                    <div className={styles.inputField}>
                      <input
                        ref={input => { this.passwordInputRef = input }}
                        className={styles.defaultTextInput}
                        autoComplete="new-password"
                        id="passwordTextField"
                        name="password"
                        onKeyDown={this.onPasswordKeydown}
                        onChange={handleChange}
                        type="password"
                        placeholder="Password"
                      />
                    </div>
                    {!CN_Instance &&
                      <div className={styles.inputField}>
                        <Select
                          className="loginSelect react-select-filter-selector"
                          classNamePrefix="loginSelect react-select-filter-selector"
                          components={{ Option, SingleValue }}
                          defaultValue={selectedOption}
                          onChange={this.handleRegionChange}
                          options={options}
                          isSearchable={false}
                        />
                      </div>
                    }
                    {(errorMsg || authTimeoutError) &&
                      <h2 className={styles.errorMsg}>{errorMsg || authTimeoutError}</h2>
                    }

                    <div className={styles.forgotPassword}>
                      <p>
                        <Link to={ROUTES.REQUEST_NEW_PASSWORD}>
                          Forgot password?
                        </Link>
                      </p>
                    </div>
                    <div>
                      {loginIsFetching ?
                        <button className={styles.disabledButton}>
                          <div className={styles.loginLoading}>
                            <Loading />
                          </div>
                        </button>
                        :
                        <button
                          className={styles.signInButton}
                          onClick={this.submitLogin}
                        >
                          <SignInArrow />
                          Sign In
                        </button>
                      }
                    </div>
                  </div>
                )
              }
            </section>

            <section className={styles.footer}>
              {CN_Instance ?
                <p className={classes.copyrightStatement}>
                  {CN_ICP}
                </p>
                :
                <CopyrightStatement />
              }

            </section>
          </div>
        </div>
      </div >
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/legacy/pages/Login/Login.jsx